// extracted by mini-css-extract-plugin
export default {"wrapper":"deleteConfirmation_wrapper__sYujo","buttons":"deleteConfirmation_buttons__rg7Sn"};